import { z } from "zod";
import { responseSchema } from "../http.js";
export const healthDataSchema = z.object({
    status: z.literal("ok"),
    service: z.string(),
    version: z.string(),
    uptimeSeconds: z.number(),
    database: z.object({
        connected: z.boolean(),
        /** Sin replica set no hay transacciones, y sin transacciones no hay dinero seguro. */
        transactionsAvailable: z.boolean(),
    }),
});
export const healthResponseSchema = responseSchema(healthDataSchema);
//# sourceMappingURL=health.js.map